import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class SenhaService {
    baseUrl = environment.url;

    constructor(private http: HttpClient) { }

    solicitarRecuperacaoSenha(dados: { cpfOuEmail: string, metodo: string }): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}v1/auth/recuperar-senha`, dados);
    }

    alterarSenha(codigo: string, novaSenha: string): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}v1/auth/redefinir-senha`, {
            "codigo": codigo,
            "novaSenha": novaSenha
        });
    }

    alterarSenhaInterno(senhaAtual: string, novaSenha: string): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}v1/auth/alterar-senha`, {
            "senhaAtual": senhaAtual,
            "novaSenha": novaSenha
        });
    }

    // Novo método para registrar o checkpoint da sessão
    registrarCheckpoint(dados: { idSessao: number, nomeSessao: string }): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}v1/auth/checkpoint`, dados);
    }
}